<template>
  <div class="retsubs" v-wechat-title="title">
    <div class="list" @click="showUls = false">
      <ul>
        <li>
          <div class="product">
            <div v-if="list && list.item_list && (list.item_list.length <= 1 && list.item_list.length > 0)" class="productBox">
              <img v-lazy="list.item_list[0].img_path">
              <div class="proContent">
                <b>{{list.item_list[0].name.length > 26 ? list.item_list[0].name.slice(0, 26) + '...' : list.item_list[0].name}}</b>
                <p>
                  <b>{{list.item_list[0].spec}}</b>
                </p>
              </div>
            </div>
            <div v-if="list && list.item_list && list.item_list.length > 1" class="productBox bestSellingSwiper" style="overflow: hidden;position:relative;">
              <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide v-for="(itemSon, idx) in list.item_list" :key="idx">
                  <img v-lazy="itemSon.img_path">
                </swiper-slide>
              </swiper>
            </div>
            <span class="totelPrice" :style="list && list.item_list && list.item_list.length > 1 ? {} : {'position': 'static'}">
              <span class="price" v-if="list.totalmoney">
                {{String(list.totalmoney).slice(0, String(list.totalmoney).indexOf('.'))}}
                <i>
                 {{String(list.totalmoney).slice((list.totalmoney).indexOf('.'), String(list.totalmoney).length)}}
                </i>
              </span>
              <b>共{{list.total}}件</b>
            </span>
          </div>
        </li>
      </ul>
    </div>
    <!--<div class="way">-->
    <!--<p>寄回方式</p>-->
    <!--<span :class="{'chooselis': wayTitle != ''}" v-if="wayTitle == ''">{{wayTitle == '' ? '选择寄回方式' : wayTitle}}&nbsp;&nbsp;<van-icon v-if="$route.query.type == 'write'" @click="showUlsClick" name="arrow-up" size="10" color="#1D1E1E"/></span>-->
    <!--<span-->
    <!--@click="showUlsClick"-->
    <!--class="chooselis"-->
    <!--v-else-if="wayTitle != ''"-->
    <!--style="color: #444;"-->
    <!--&gt;{{wayTitle}}&nbsp;&nbsp;<van-icon name="arrow-up" size="10" color="#1D1E1E"/></span>-->
    <!--<div class="waylist" v-if="showUls">-->
    <!--<img src="../../assets/images/jt5.png">-->
    <!--<ul>-->
    <!--<li v-for="(item, index) in waylist" :key="index" @click="chooseLisClick(item)">{{item}}</li>-->
    <!--</ul>-->
    <!--</div>-->
    <!--</div>-->
    <!--<div class="address get expInfo" @click="showUls = false">-->
    <!--<p>取件地址</p>-->
    <!--<ul>-->
    <!--<li>-->
    <!--<p><img src="../../assets/images/position.png">&nbsp;&nbsp;售后部收&nbsp;&nbsp;029-87649263</p>-->
    <!--<i><b>陕西省西安市雁塔区瞪羚路巨子生物3</b><van-icon name="arrow" size="10" /></i>-->
    <!--</li>-->
    <!--<li @click="courierTime">-->
    <!--<p><img src="../../assets/images/date.png">&nbsp;&nbsp;6月22日(星期六)&nbsp;&nbsp;9:00-18:00</p>-->
    <!--<van-icon name="arrow" size="10" />-->
    <!--</li>-->
    <!--</ul>-->
    <!--</div>-->
    <!--<div class="contact expInfo" @click="showUls = false">-->
    <!--<p>取件人信息</p>-->
    <!--<ul>-->
    <!--<li>-->
    <!--<p style="min-width: 0.48rem;">联系人</p>-->
    <!--<input type="text" placeholder="请输入联系人">-->
    <!--</li>-->
    <!--<li>-->
    <!--<p style="min-width: 0.48rem;">联系电话</p>-->
    <!--<input type="text" placeholder="请输入联系电话">-->
    <!--</li>-->
    <!--</ul>-->
    <!--</div>-->
    <div class="expInfo" @click="showUls = false">
      <p>快递信息</p>
      <ul v-if="$route.query.type == 'write'">
        <li>
          <p style="min-width: 0.48rem;">快递公司</p>
          <span @click="chooseCourier" v-if="CourierTitle == ''">选择快递公司&nbsp;&nbsp;<van-icon name="arrow" color="#1D1E1E"/></span>
          <span @click="chooseCourier" v-else-if="CourierTitle != ''" style="color: #444;">{{CourierTitle}}&nbsp;&nbsp;<van-icon name="arrow" color="#1D1E1E"/></span>
        </li>
        <li>
          <p style="min-width: 0.48rem;">快递号码</p>
          <input type="text" @blur="input_blur"  placeholder="输入快递号码" v-model="CourierNum">
        </li>
      </ul>
      <ul v-if="$route.query.type == 'query'">
        <li>
          <p style="min-width: 0.48rem;">快递公司</p>
          <span style="color: #444;background: #F6F7FA">{{list.trans_name}}&nbsp;&nbsp;</span>
        </li>
        <li>
          <p style="min-width: 0.48rem;">快递号码</p>
          <input style="background: #F6F7FA;color:#444;" type="text" placeholder="输入快递号码" :value="list.trans_no" disabled>
        </li>
      </ul>
    </div>
    <div class="address expInfo">
      <p>收件地址</p>
      <ul>
        <li>
          <p><img src="../../assets/images/position.png">&nbsp;&nbsp;{{list.service_name}}&nbsp;&nbsp;{{list.service_phone}}</p>
          <b>{{list.servcie_address}}</b>
        </li>
      </ul>
    </div>
    <button v-if="$route.query.type == 'write'" class="submit" @click="submit">提交</button>
    <!--<van-action-sheet v-model="show" title="上门时间" round>-->
    <!--<img @click="show = false" src="../../assets/images/close3.png" style="width: 0.2rem;height: 0.2rem;position: absolute;right: 0.16rem;top: 0.12rem;">-->
    <!--<van-tree-select-->
    <!--:items="items"-->
    <!--:main-active-index="mainActiveIndex"-->
    <!--:active-id="activeId"-->
    <!--@click-nav="onClickNav"-->
    <!--@click-item="onClickItem"-->
    <!--/>-->
    <!--</van-action-sheet>-->
    <choose-courier v-if="courierShow" @title="titleChild" @courier="courierChild"></choose-courier>
  </div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { customRequestAjax } from '@/axiosApi'
import chooseCourier from './chooseCourier'
import { isWeixin, kefu, fenxiang } from '../../assets/common/js/config'
import Vue from 'vue'
Vue.use(VueAwesomeSwiper /* { default global options } */)
export default {
  name: 'ReturnSubsequent',
  data () {
    return {
      id: this.$route.query.id ? this.$route.query.id : '',
      type: this.$route.query.type ? this.$route.query.type : '',
      totalmoney: 0,
      nums: 0,
      CourierNum: '',
      swiperOption: {
        autoplay: false,
        slidesPerView: 'auto',
        slidesPerGroup: 2,
        observer: true,
        observeParents: true,
        spaceBetween: 10
      },
      list: [],
      // mainActiveIndex: 0,
      // activeId: 0,
      waylist: ['自寄', '上门取件'],
      wayTitle: '',
      showUls: false,
      // show: false,
      CourierTitle: '',
      courierShow: false,
      title: '退货'// this.courierShow ? '退货' : '快递公司'
    }
  },
  components: {
    chooseCourier
  },
  mounted: function () {
    this.$route.meta.title = this.title
    if (isWeixin()) {
      fenxiang({path: 'returnsubsequent'})
    }
    this.getData()
    // if (this.$route.query.title) {
    //   this.CourierTitle = decodeURIComponent(this.$route.query.title)
    // }
  },
  methods: {
    getData () {
      var queryUrl = 'Wxmall/OrderRefund/getRefundOrderTransInfo?id=' + this.id
      var writeUrl = 'Wxmall/OrderRefund/getRefundOrderTrans?id=' + this.id
      var that = this
      if (that.type == 'query') {
        customRequestAjax(queryUrl).then(res => {
          if (res.data.code === 200) {
            that.list = res.data
            that.list.item_list.map(item => {
              that.totalmoney = that.totalmoney + parseFloat(item.back_price)
              that.nums = that.nums + parseInt(item.num)
            })
          }
        })
      } else if (that.type == 'write') {
        customRequestAjax(writeUrl).then(res => {
          if (res.data.code === 200) {
            that.list = res.data
            // if (sessionStorage.getItem('store_info')) {
            //   fenxiang({
            //     type: 'index',
            //   })
            // }
            that.list.item_list.map(item => {
              that.totalmoney = that.totalmoney + parseFloat(item.back_price)
              that.nums = that.nums + parseInt(item.num)
            })
            sessionStorage.setItem('express_list', JSON.stringify(that.list.express))
          }
        })
      }
    },
    titleChild (n) {
      this.CourierTitle = n
    },
    courierChild (n) {
      this.courierShow = n
      this.title = this.$route.meta.title = '退货'
    },
    showUlsClick: function () {
      this.showUls = !this.showUls
    },
    chooseLisClick: function (items) {
      this.wayTitle = items
      this.showUls = false
    },
    chooseCourier: function () {
      this.courierShow = true
      this.title = this.$route.meta.title = '快递公司'
      // this.$router.push({
      //   path: '/choosecourier',
      //   query: {
      //     id: this.id,
      //     type: 'write'
      //   }
      // })
    },
    submit () {
      var url = 'Wxmall/OrderRefund/saveRefundOrderTransInfo'
      var data = {
        id: this.id,
        type: 1,
        trans_name: this.CourierTitle,
        trans_no: this.CourierNum
      }
      var that = this
      if (this.type == 'write') {
        that.$dialog.confirm({
          message: '为了保证退款的时效性，请正确填写快递信息，我们将在第一时间为您处理退款。',
          className: 'collect_button_alert',
          cancelButtonColor: '#FC0324',
          confirmButtonColor: '#FFFCFC',
          confirmButtonText: '直接提交',
          cancelButtonText: '重新修改',
          closeOnPopstate: true
        }).then(function () {
          // on confirm
          customRequestAjax.post(url, data).then(res => {
            if (res.data.code === 200) {
              that.$store.commit('ORDER_INIT_DATA', 1)
              that.$router.replace({
                path: '/afterdetails',
                query: {
                  id: that.id
                }
              })
            }
          })
        }).catch(function () {
          // on cancel
        })
      }
    },
    input_blur () {
      // document.body.scrollTop = document.documentElement.scrollTop - 1
      setTimeout(() => {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight, 0))
      }, 100)
    }
    // courierTime: function () {
    //   this.show = true
    // },
    // onClickNav (index) {
    //   this.mainActiveIndex = index
    // },
    // onClickItem (data) {
    //   this.activeId = data.id
    //   var that = this
    //   setTimeout(function () {
    //     that.show = false
    //   }, 200)
    // }
  }
}
</script>

<style scoped lang="scss">
  .list ul li p, .list ul li .proFooter, .product,.why,.expInfo ul li,.expInfo ul li span,.get ul li i,.expInfo.address.get ul li:last-of-type {
    display: flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: -o-flex;
    justify-content: space-between;
    -moz-justify-content: space-between;
    -ms-justify-content: space-between;
    -webkit-justify-content: space-between;
    -o-justify-content: space-between;
    align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -webkit-align-items: center;
    -o-align-items: center;
  }
  .retsubs {
    .list {
      padding: 0.2rem 0.15rem;
      margin: 0.1rem 0.11rem;
      background: #fff;
      >ul {
        /*margin-bottom: 0.11rem;*/
        >li {
          background: #fff;
          margin-bottom: 0.1rem;
          &:last-of-type {
            margin-bottom: 0;
          }
          /*margin: 0.11rem 0.11rem 0;*/
          /*padding: 0.15rem 0.15rem 0;*/
          >p {
            border-bottom: 1px solid #EFEFEF;
            padding-bottom: 0.1rem;
            span {
              display: block;
              b {
                display: block;
                font-weight: 400;
                color: #444444;
                font-size:0.12rem;
                float: left;
                &:last-of-type {
                  margin-left: 0.04rem;
                }
              }
            }
            i {
              font-style: normal;
              color: #292929;
              font-size: 0.12rem;
              display: flex;
              display: -o-flex;
              display: -webkit-flex;
              display: -ms-flex;
              display: -moz-flex;
              align-items: center;
              -o-align-items: center;
              -webkit-align-items: center;
              -ms-align-items: center;
              -moz-align-items: center;
              b{
                border-left: 1px solid #D8D8D8;
                margin-left: 0.06rem;
                padding-left: 0.07rem;
                display: flex;
                display: -o-flex;
                display: -webkit-flex;
                display: -ms-flex;
                display: -moz-flex;
                align-items: center;
                -o-align-items: center;
                -webkit-align-items: center;
                -ms-align-items: center;
                -moz-align-items: center;
                img {
                  width:0.12rem;
                  height:0.12rem;
                }
              }
            }
          }
          .product {
            position: relative;
            .productBox {
              display: flex;
              display: -moz-flex;
              display: -ms-flex;
              display: -webkit-flex;
              display: -o-flex;
              img {
                width: 0.8rem;
                height: 0.8rem;
              }
              .proContent {
                margin-left: 0.07rem;
                margin-top: 0.08rem;
                flex: 1;
                -webkit-flex: 1;
                -moz-flex: 1;
                -ms-flex: 1;
                -o-flex: 1;
                >b {
                  font-size:0.13rem;
                  font-weight:400;
                  color:rgba(41,41,41,1);
                  line-height:0.18rem;
                  display: block;
                  margin-bottom: 0.05rem;
                }
                >p{
                  align-items: flex-start;
                  -moz-align-items: flex-start;
                  -ms-align-items: flex-start;
                  -webkit-align-items: flex-start;
                  -o-align-items: flex-start;
                  >b {
                    font-size:0.11rem;
                    font-weight:400;
                    color:rgba(108,108,108,1);
                    line-height:0.16rem;
                    display: block;
                  }
                }
                .choicesNum {
                  height: 0.22rem;
                  margin-top: 0.11rem;
                }
              }
            }
            .totelPrice {
              position: absolute;
              right: 0;
              z-index: 10;
              opacity:0.85;
              height: 0.8rem;
              display: flex;
              display: -webkit-flex;
              display: -o-flex;
              display: -ms-flex;
              display: -moz-flex;
              flex-direction: column;
              -webkit-flex-direction: column;
              -o-flex-direction: column;
              -ms-flex-direction: column;
              -moz-flex-direction: column;
              justify-content: center;
              -webkit-justify-content: center;
              -o-justify-content: center;
              -ms-justify-content: center;
              -moz-justify-content: center;
              .price {
                display: flex;
                display: -webkit-flex;
                display: -o-flex;
                display: -ms-flex;
                display: -moz-flex;
                align-items: flex-end;
                -webkit-align-items: flex-end;
                -o-align-items: flex-end;
                -ms-align-items: flex-end;
                -moz-align-items: flex-end;
                font-size: 0.14rem;
                font-weight:600;
                color:#222222;
                line-height:0.14rem;
                &:before {
                  content: '￥';
                  font-size:0.10rem;
                  font-weight:600;
                  line-height: 0.14rem;
                }
                i {
                  font-size: 0.11rem;
                  font-style: normal;
                  line-height: 0.14rem;
                }
              }
              >b {
                color: #908D8D;
                font-size: 0.11rem;
                line-height: 0.16rem;
                display: block;
                font-weight:400;
                text-align: center;
              }
            }
            .bestSellingSwiper {
              .swiper-container {
                padding-right: 0.6rem;
              }
              .swiper-wrapper {
                .swiper-slide {
                  width: 0.8rem;
                  position: relative;
                  background-color: white;
                }
              }
              &+.totelPrice {
                background:rgba(255,255,255,1);
                box-shadow:-0.2rem 0 0.09rem -0.16rem rgba(156,156,156,0.5);
              }
            }
          }
        }
      }
    }
    .way {
      height: 0.45rem;
      padding: 0.14rem 0.14rem 0.13rem 0.15rem;
      margin: 0.1rem 0.11rem 0;
      border-radius: 0.03rem;
      background: #fff;
      position: relative;
      p {
        float: left;
        font-size: 0.13rem;
        color: #000;
      }
      span {
        float: right;
        /*display: block;*/
        font-size: 0.12rem;
        color: #B0B0B0;
        display: flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -webkit-flex;
        display: -o-flex;
        align-items: center;
        -moz-align-items: center;
        -ms-align-items: center;
        -webkit-align-items: center;
        -o-align-items: center;
        &.chooselis {
          color: #444444;
        }
      }
      .waylist {
        position: absolute;
        background: #fff;
        left: 0;
        right: 0;
        bottom: -0.95rem;
        box-shadow:0 0.04rem 0.29rem -0.03rem rgba(157,157,157,0.5);
        -moz-box-shadow:0 0.04rem 0.29rem -0.03rem rgba(157,157,157,0.5);
        -ms-box-shadow:0 0.04rem 0.29rem -0.03rem rgba(157,157,157,0.5);
        -webkit-box-shadow:0 0.04rem 0.29rem -0.03rem rgba(157,157,157,0.5);
        -o-box-shadow:0 0.04rem 0.29rem -0.03rem rgba(157,157,157,0.5);
        padding: 0 0.15rem;
        >img {
          width: 0.18rem;
          height: 0.1rem;
          position: absolute;
          top: -0.1rem;
          right: 0.3rem;
          box-shadow:0 0.04rem 0.29rem -0.03rem rgba(157,157,157,0.5);
          -moz-box-shadow:0 0.04rem 0.29rem -0.03rem rgba(157,157,157,0.5);
          -ms-box-shadow:0 0.04rem 0.29rem -0.03rem rgba(157,157,157,0.5);
          -webkit-box-shadow:0 0.04rem 0.29rem -0.03rem rgba(157,157,157,0.5);
          -o-box-shadow:0 0.04rem 0.29rem -0.03rem rgba(157,157,157,0.5);
        }
        ul {
          li {
            padding: 0.14rem 0 0.13rem 0;
            text-align: right;
            font-size:0.12rem;
            font-weight:400;
            color:rgba(0,0,0,1);
            line-height:0.17rem;
            &:last-of-type {
              border-top: 1px solid #D1D1D1;
            }
          }
        }
      }
    }
    .expInfo {
      padding: 0.15rem 0.15rem 0.2rem;
      margin: 0.1rem 0.11rem;
      background: #fff;
      border-radius: 0.03rem;
      >p{
        font-size:0.13rem;
        font-weight:600;
        color:rgba(0,0,0,1);
        line-height:0.18rem;
        padding-bottom: 0.1rem;
        border-bottom: 1px solid #D8D8D8;
      }
      ul{
        padding-top: 0.16rem;
        li{
          margin-bottom: 0.07rem;
          &:last-of-type {
            margin-bottom: 0;
          }
          p{
            font-size:0.12rem;
            font-weight:400;
            color:rgba(29,30,30,1);
            line-height:0.17rem;
            margin-right: 0.11rem;
          }
          span {
            flex: 1;
            -o-flex: 1;
            -webkit-flex: 1;
            -moz-flex: 1;
            -ms-flex: 1;
            font-size:0.13rem;
            font-weight:400;
            color:rgba(153,153,153,1);
            height: 0.32rem;
            border-radius: 0.02rem;
            background: #F6F7FA;
            line-height: 0.32rem;
            padding-left: 0.14rem;
            padding-right: 0.09rem;
          }
          input {
            padding-left: 0.14rem;
            background: #F6F7FA;
            border: 0;
            outline: none;
            height: 0.32rem;
            border-radius: 0.02rem;
            font-size:0.13rem;
            color: #333;
            flex: 1;
            -o-flex: 1;
            -webkit-flex: 1;
            -moz-flex: 1;
            -ms-flex: 1;
            &::placeholder{
              font-size:0.13rem;
              font-weight:400;
              color:rgba(153,153,153,1);
              line-height:0.18rem;
            }
          }
        }
      }
    }
    .address {
      ul {
        li {
          display: block;
          p {
            font-size:0.12rem;
            font-weight:600;
            color:rgba(29,30,30,1);
            line-height:0.17rem;
            img {
              padding: 0.01rem 0.02rem;
              width: 0.16rem;
              height: 0.16rem;
              float: left;
            }
          }
          b {
            padding-left: 0.23rem;
            display: block;
            margin-top: 0.06rem;
            font-size:0.11rem;
            font-weight:400;
            color:rgba(149,149,149,1);
            line-height:0.16rem;
          }
        }
      }
    }
    .get {
      ul {
        li {
          i {
            margin-top: 0.06rem;
            font-style: normal;
            b{
              margin-top: 0;
            }
          }
          &:last-of-type {
            margin-top: 0.13rem;
          }
        }
      }
    }
    .submit {
      background: #FC0324;
      border: 0;
      outline: none;
      height: 0.45rem;
      width: 100%;
      font-size: 0.13rem;
      color: #FFFFFF;
      line-height: 0.45rem;
      display: block;
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
</style>
<style lang="scss">
  .retsubs {
    .van-action-sheet__close {
      color: transparent !important;
    }
    .van-tree-select__nav-item--active {
      border-color: transparent !important;
      color: #FC0324 !important;
    }
    .van-tree-select__item--active {
      color: #3A3A3A !important;
    }
    .van-tree-select__item {
      font-weight: 400 !important;
      border-bottom: 0.01rem solid #D1D1D1 !important;
    }
    .van-tree-select__item:last-of-type {
      border-bottom: 0.01rem solid transparent !important;
    }
    .van-tree-select__selected {
      color: #FC0324 !important;
    }
    .van-tree-select__content {
      padding: 0 0.15rem 0 0.11rem !important;
    }
    .van-tree-select__nav-item {
      border-bottom: 0.01rem solid #D1D1D1 !important;
    }
    .van-action-sheet__header {
      border-bottom: 0.01rem solid #EFEFEF !important;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/after/ReturnSubsequent.vue